import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {OrganizationDocument, OrganizationDocumentSearchParams} from '@documents/_common/models/organization-document.models';
import {CategoryListResponse, EntityCategoryTree} from '@common/components-standalone/reference-category-module/category.type';
import {CategoriesTreeState} from '@common/models/entity-state.models';
import {BindOrganizationDocumentRequest} from '@documents/organization-document/_models/organization-document.models';

export const CheckState = createAction(
    '[OrganizationDocuments] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: OrganizationDocument[] } }>()
);

export const CheckStateSuccess = createAction(
    '[OrganizationDocuments] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: OrganizationDocument[] } }>()
);

export const LoadCategories = createAction(
    '[OrganizationDocuments] Load Categories',
    props<{ forceUpdate: boolean }>()
);

export const LoadCategoriesSuccess = createAction(
    '[OrganizationDocuments] Load Categories Success',
    props<{ payload: CategoryListResponse[] }>()
);

export const UpsertCategory = createAction(
    '[OrganizationDocuments] Upsert Category',
    props<{ payload: CategoryListResponse }>()
);

export const DeleteCategory = createAction(
    '[OrganizationDocuments] Delete Category',
    props<{ payload: EntityCategoryTree }>()
);

export const SetCategoriesState = createAction(
    '[OrganizationDocuments] Set Categories State',
    props<{ payload: CategoriesTreeState }>()
);

export const LoadList = createAction(
    '[OrganizationDocuments] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[OrganizationDocuments] Load List Success',
    props<{ payload: { items: OrganizationDocument[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[OrganizationDocuments] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[OrganizationDocuments] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[OrganizationDocuments] Set Filter',
    props<{ payload: OrganizationDocumentSearchParams, selectedCategory?: EntityCategoryTree }>()
);

export const SetLoading = createAction(
    '[OrganizationDocuments] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[OrganizationDocuments] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[OrganizationDocuments] Update Item Success',
    props<{ payload: OrganizationDocument }>()
);

export const DeleteItem = createAction(
    '[OrganizationDocuments] Delete Item',
    props<{ payload: OrganizationDocument }>()
);

export const DeleteItemSuccess = createAction(
    '[OrganizationDocuments] Delete Item Success',
    props<{ payload: OrganizationDocument }>()
);

export const DeleteItemFailure = createAction(
    '[OrganizationDocuments] Delete Item Failure',
    props<{ payload: OrganizationDocument }>()
);

export const SetInitialState = createAction(
    '[OrganizationDocuments] Set Initial State'
);

export const BindDocument = createAction(
    '[OrganizationDocuments] Bind Document',
    props<{ payload: {attachmentId: string, request: BindOrganizationDocumentRequest}}>()
);

export const UnbindDocument = createAction(
    '[OrganizationDocuments] Unbind Document',
    props<{ payload: {attachmentId: string, request: BindOrganizationDocumentRequest, lastDocumentUnbinded?: boolean, deleteDocument?: boolean}}>()
);
